export type QuoteItemLink = {
  label: string;
  href: string;
};

export type QuoteItem = {
  quote: string;
  attribution: string;
  image: string;
  badges?: string[];
  link: QuoteItemLink | null;
};

export type QuoteCarouselProps = {
  title: string;
  quotes: QuoteItem[];
};

export function parseQuoteItemLink(link: QuoteItemLink | null | undefined): QuoteItemLink | null {
  if (!link) return null;

  const label = link.label?.trim() ?? '';
  const href = link.href?.trim() ?? '';

  if (!label || !href) return null;

  return { label, href };
}
